import { Injectable } from '@angular/core';
import { IID_ASSURANCE_TICKET } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDassuranceTicketStore } from './iidAssuranceTicket.store';
import { IIDassuranceTicketQuery } from './iidAssuranceTicket.query';
import { WsACKCallback } from '@common/api/ack';
import { RealtimeFeatureCommandService } from '@ep-om/realtime-v2';
import { IssueQuery } from '../issue/issue.query';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.ASSURANCE_TICKET)
export class IIDassuranceTicketService extends CrudService<IID_ASSURANCE_TICKET, IIDassuranceTicketStore, IIDassuranceTicketQuery> {
  constructor(
    protected store: IIDassuranceTicketStore,
    public query: IIDassuranceTicketQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    private featureCommandService: RealtimeFeatureCommandService,
    private issueQuery: IssueQuery) {
    super(
      Topics.IID_ASSURANCE_TICKET,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

  createTaskOnGuastiNID(sourceIssueId: string, projectDestinationId: string, issueTypeDestinationId: string, callback?: WsACKCallback<void>) {
    const dto = { sourceIssueId, projectDestinationId, issueTypeDestinationId };
    this.featureCommandService.send<void>(
      {
        target: 'feature:assurance-ticket',
        command: 'create-task-on-guasti-nid',
        dto,
        ...this.projectIdFromIssue(sourceIssueId),
      },
      () => this.actionService.sendMessage(Topics.IID_ASSURANCE_TICKET, 'createTaskOnGuastiNID', dto, callback),
      callback,
    );
  }

  private projectIdFromIssue(issueId: string): { projectId?: string } {
    const projectId = this.issueQuery.getEntity(issueId)?.projectId;
    return projectId ? { projectId } : {};
  }
}
